module.exports = __webpack_public_path__ + "img/pmed-bg.3092c0ec.jpg";